export {
    ContentBlocksInline,
    type InlineCardProps,
    type PatternInlineContentProps
} from "./content-blocks-inline";
export { ContentBlocksInline as default } from "./content-blocks-inline";
